import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgElevator = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "lift" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: .75,
			width: 22.5,
			height: 22.5,
			rx: 1,
			ry: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6,23.25V10.5a.75.75,0,0,1,.75-.75h10.5a.75.75,0,0,1,.75.75V23.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 9.75,
			x2: 12,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "5.25 6.75 7.5 3.75 9.75 6.75"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "18 3.75 15.75 6.75 13.5 3.75"
		})
	]
});
export default SvgElevator;
